import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@hydra/common/components/Button';
import Container from '@material-ui/core/Container';

import rocket from '@hydra/assets/img/review/rocket.png';
import Translate, { useI18n } from '@hydra/common/components/i18n';
import Image from '@hydra/common/components/Image';
import settings from '@hydra/utils/settings';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(9),
    backgroundColor: theme.palette.success.main,
    marginBottom: theme.spacing(9),
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(7.5)
    }
  },
  heading: {
    color: theme.palette.success.contrastText,
    fontSize: theme.typography.fontSizeXLarge,
    fontWeight: theme.typography.fontWeightSemibold,
    lineHeight: 1.4,
    marginBottom: theme.spacing(4.5)
  },
  btn: {
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.success.contrastText,
    color: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.smoke
    }
  },
  icon: {
    marginBottom: theme.spacing(3)
  }
}));

export default function ReviewTeaserCTA (props) {
  const {
    btnText,
    icon = false
  } = props;
  const classes = useStyles();
  const { locale } = useI18n();

  return (
    <Container maxWidth={false} className={classes.wrapper}>
      {icon && (
        <Image
          className={classes.icon}
          src={rocket}
          alt=''
          width='57'
          height='57'
        />
      )}
      <Typography
        component='h2'
        variant='h2'
        color='textPrimary'
        className={classes.heading}
      >
        <Translate content='free_review_start_your_free_trial_dynamic_trial' with={{ trial: settings.get('trialPeriod') }} />
      </Typography>
      <Button
        variant='contained'
        size='large'
        className={classes.btn}
        href={`/${locale}/register/plan/v2pro`}
      >
        <Translate content={btnText} />
      </Button>
    </Container>
  );
}
